import type { FunctionalComponent } from 'preact'

/**
 * The two outward-link marks shared by the company profile's identity line and the company cell in
 * the Companies grids. Components only — the URL sanitiser lives in companyLinks.ts, because a
 * module exporting components must export nothing else for fast refresh to work.
 */

export const LinkedInGlyph: FunctionalComponent<{ class?: string }> = ({ class: className = 'w-3.5 h-3.5' }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" class={className} aria-hidden="true">
    <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9h4v12H3zM9 9h3.8v1.7h.05c.53-1 1.83-2.05 3.77-2.05C20.6 8.65 21 11 21 14.1V21h-4v-6.1c0-1.45-.03-3.3-2-3.3-2 0-2.3 1.57-2.3 3.2V21H9z" />
  </svg>
)

export const GlobeGlyph: FunctionalComponent<{ class?: string }> = ({ class: className = 'w-3.5 h-3.5' }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class={className} aria-hidden="true">
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3c2.5 2.7 2.5 15.3 0 18M12 3c-2.5 2.7-2.5 15.3 0 18" />
  </svg>
)
